import React, { useContext } from 'react';

import { Link } from 'react-router';

import { type Company, CompanyContext } from 'common/containers/CompanyContainer';
import { useOnboardingContext } from 'common/containers/OnboardingContainer';
import { IntegrationOptionValue } from 'common/subdomain/admin/AdminOnboarding/constants';
import {
  type IntegrationOptionValueKey,
  integrations,
} from 'common/subdomain/admin/AdminOnboarding/data';
import OnboardingIntegrationCard from 'common/subdomain/admin/AdminOnboarding/InAppOnboarding/OnboardingIntegrationCard';
import VStack from 'common/uiV3/VStack';

const OnboardingIntegrations = () => {
  const company = useContext(CompanyContext);
  const { onboarding } = useOnboardingContext();

  const selectedIntegrations = Array.from(
    new Set([
      ...(onboarding.communicationTools || []),
      ...(onboarding.internalTools || []),
      ...(onboarding.projectManagementTools || []),
    ]).values(),
  ).filter((tool) => Object.values(IntegrationOptionValue).includes(tool as any));

  const hasUnselectedIntegrations = Object.values(IntegrationOptionValue).some(
    (source) => !selectedIntegrations?.includes(source),
  );

  return (
    <VStack className="gap-4">
      {selectedIntegrations?.map((integration) => {
        const integrationID = integration as keyof typeof integrations;

        return (
          <OnboardingIntegrationCard
            key={integration}
            icon={integrations[integrationID].icon}
            title={integrations[integrationID].label}
            description={integrations[integrationID].description}
            href={integrations[integrationID].url}
            isInstalled={company?.activeIntegrations[integrationID] ?? false}
            tag={integrations[integrationID].tag}
            installButtonTitle={integrations[integrationID].installButtonTitle}
          />
        );
      })}
      {hasUnselectedIntegrations && (
        <Link to="/admin/settings/integrations/all">
          <button className="unstyled-button self-start px-1.5 underline font-medium text-gray-110 text-body">
            Show all integrations
          </button>
        </Link>
      )}
    </VStack>
  );
};

const isIntegrationInstalled = (integrationID: IntegrationOptionValueKey, company: Company) => {
  return company?.activeIntegrations[integrationID] ?? false;
};

export const isSelectedIntegrationsInstalled = (company: Company) => {
  return Object.keys(integrations).some((integrationID) =>
    isIntegrationInstalled(integrationID as IntegrationOptionValueKey, company),
  );
};

export default OnboardingIntegrations;
